<template>
    <div id="failed-uploading-modal" class="hidden modal-new">
        <btnClose></btnClose>
        <span class="title">We couldn't upload some files</span>
        <p class="description text-left">There might have been a temporary problem with your internet connection or
            unexpected error. Please try again in a few moments.</p>

        <v-row class="font-weight-bold ma-0 mb-4">
            <v-col sm="8" class="pl-0">
                Name
            </v-col>
            <v-col sm="4" class="">
                Type
            </v-col>
        </v-row>

        <div class="list-con mx-0">
            <v-row v-for="file in failedUploadsList" :key="file.id" class="ma-0">
                <v-col sm="8" class="pl-0">
                    <span>{{ stripTimestampAndExtension(file.name) }}</span>
                </v-col>

                <v-col sm="4" class="">
                    <span>{{ capitalizeFirstLetter(file.type) }}</span>
                </v-col>
            </v-row>
        </div>

        <div class="buttons-continer">
            <button type="button" class="modal-btn --primary" @click="onConfirm">
                <span>Close</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import btnClose from "@/components/app/buttons/modal/Close";
import FilenameMixin from "@/mixins/Filename";

export default {
    mixins: [FilenameMixin],

    components: {
        btnClose,
    },

    computed: {
        ...mapState("Projects", ["failedUploadsList"]),
    },

    methods: {
        onConfirm() {
            window.UI.hideModal();
            this.active = [];
            this.openBins = [];
        },
    },
};
</script>

<style lang="scss">
#failed-uploading-modal {
    .list-con {
        margin-bottom: 30px;
    }
}
</style>
